module.exports = __webpack_public_path__ + "assets/img/loading.0a07c82d.gif";